var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { usePanorama } from './usePanorama';
export var withPanorama = function (Component) {
    var Wrapped = function (props) {
        var panoramaClient = usePanorama();
        return React.createElement(Component, __assign({}, __assign(__assign({}, props), { panoramaClient: panoramaClient })));
    };
    return Wrapped;
};
//# sourceMappingURL=withPanorama.js.map